export const cardsData = [
  {
    id: 'card-1',
    title: '完结漫画全集一次性畅读',
    tag: '完结推荐',
    description: '收录超过2000部已完结漫画全集，从经典神作到小众精品，无需等待连载，一口气看到大结局。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20illustration%20of%20a%20stack%20of%20comic%20books%20with%20colorful%20covers%20on%20a%20wooden%20desk%2C%20soft%20natural%20light%20from%20window%2C%20cozy%20reading%20atmosphere%2C%20artistic%20style%20with%20warm%20amber%20and%20coral%20tones%2C%20editorial%20photography%20composition%2C%20simple%20clean%20background&width=800&height=500&seq=comic-card-01&orientation=landscape',
    alt: '完结漫画全集',
    link: '#index',
  },
  {
    id: 'card-2',
    title: '高人气连载每日同步更新',
    tag: '热门连载',
    description: '追踪最热门连载漫画，与日本、国漫同步更新，最新章节第一时间推送，追更不掉队。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20digital%20illustration%20of%20manga%20pages%20spread%20open%20showing%20action%20scenes%2C%20Japanese%20comic%20style%20artwork%2C%20soft%20amber%20lighting%2C%20clean%20minimal%20background%20with%20warm%20coral%20accents%2C%20editorial%20style%20composition&width=800&height=500&seq=comic-card-02&orientation=landscape',
    alt: '热门连载漫画',
    link: '#ranking',
  },
  {
    id: 'card-3',
    title: '漫画全集下载离线随心看',
    tag: '下载专区',
    description: '支持高清漫画全集下载，无网络也能畅快阅读，地铁通勤、旅行途中随时随地享受漫画乐趣。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20illustration%20of%20a%20tablet%20displaying%20colorful%20comic%20pages%20on%20a%20cozy%20sofa%20with%20a%20warm%20blanket%2C%20soft%20indoor%20lighting%2C%20comfortable%20reading%20scene%2C%20warm%20amber%20and%20cream%20tones%2C%20clean%20minimal%20composition&width=800&height=500&seq=comic-card-03&orientation=landscape',
    alt: '漫画全集下载',
    link: '#app',
  },
  {
    id: 'card-4',
    title: '系列漫画大全分类清晰',
    tag: '分类浏览',
    description: '按题材、作者、年代智能分类，热血、恋爱、悬疑、搞笑等类型一应俱全，快速找到你的菜。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20illustration%20of%20organized%20colorful%20comic%20book%20shelves%20categorized%20by%20genre%2C%20library%20style%20display%2C%20soft%20warm%20lighting%2C%20clean%20aesthetic%20with%20amber%20and%20cream%20tones%2C%20editorial%20photography%20style&width=800&height=500&seq=comic-card-04&orientation=landscape',
    alt: '系列漫画大全分类',
    link: '#index',
  },
  {
    id: 'card-5',
    title: '飞飞漫画网专属阅读体验',
    tag: '平台特色',
    description: '智能分页、夜间模式、书签收藏、阅读记录云同步，打造最舒适的漫画全集在线看体验。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20illustration%20of%20a%20person%20comfortably%20reading%20comics%20on%20a%20large%20screen%20in%20a%20cozy%20dark%20room%20with%20warm%20ambient%20light%2C%20modern%20minimal%20interior%2C%20soft%20coral%20and%20amber%20color%20palette&width=800&height=500&seq=comic-card-05&orientation=landscape',
    alt: '飞飞漫画网阅读体验',
    link: '#features',
  },
];

export const rankingData = [
  { rank: 1, title: '咒术回战', tag: '热血', status: '连载中', heat: '987万', chapter: '第271话', trend: 'up' },
  { rank: 2, title: '海贼王', tag: '冒险', status: '连载中', heat: '965万', chapter: '第1130话', trend: 'up' },
  { rank: 3, title: '鬼灭之刃', tag: '热血', status: '已完结', heat: '942万', chapter: '全205话', trend: 'stable' },
  { rank: 4, title: '间谍过家家', tag: '搞笑', status: '连载中', heat: '918万', chapter: '第103话', trend: 'up' },
  { rank: 5, title: '进击的巨人', tag: '奇幻', status: '已完结', heat: '896万', chapter: '全139话', trend: 'stable' },
  { rank: 6, title: '电锯人', tag: '暗黑', status: '连载中', heat: '874万', chapter: '第182话', trend: 'up' },
  { rank: 7, title: '排球少年', tag: '运动', status: '已完结', heat: '851万', chapter: '全402话', trend: 'stable' },
];

export const carouselData = [
  {
    id: 'focus-1',
    title: '「咒术回战」最终章突入',
    tag: '焦点专题',
    description: '芥见下下倾力打造的暗黑热血巨作进入最终篇章，虎杖悠仁与宿傩的最终对决全面展开，咒术世界的命运走向终局。飞飞漫画网同步更新每一话，不错过任何一个精彩瞬间。',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20manga%20style%20illustration%20of%20two%20powerful%20characters%20facing%20off%20in%20an%20epic%20battle%20scene%2C%20dark%20atmosphere%20with%20glowing%20energy%20effects%2C%20Japanese%20comic%20art%20style%2C%20warm%20amber%20and%20deep%20coral%20accents%2C%20cinematic%20composition%2C%20dramatic%20lighting&width=1200&height=600&seq=carousel-01&orientation=landscape',
    alt: '咒术回战最终章',
  },
  {
    id: 'focus-2',
    title: '「海贼王」艾尔巴夫篇启航',
    tag: '连载追踪',
    description: '路飞一行人抵达巨人国度艾尔巴夫，全新冒险篇章正式开启。传说中的太阳神尼卡与巨人族的秘密即将揭晓，飞飞漫画网持续为你追踪最新连载。',
    image: 'https://readdy.ai/api/search-image?query=A%20grand%20adventure%20manga%20style%20illustration%20of%20a%20pirate%20ship%20approaching%20a%20giant%20mythical%20island%20with%20ancient%20ruins%2C%20warm%20golden%20sunset%20lighting%2C%20epic%20scale%2C%20Japanese%20comic%20art%20style%2C%20vibrant%20yet%20warm%20color%20palette&width=1200&height=600&seq=carousel-02&orientation=landscape',
    alt: '海贼王艾尔巴夫篇',
  },
  {
    id: 'focus-3',
    title: '2024国漫崛起年度盘点',
    tag: '年度特辑',
    description: '从「一人之下」到「镖人」，从「狐妖小红娘」到「全职高手」，国漫精品不断涌现。飞飞漫画网整理年度必看国漫完结与连载作品，带你感受国漫的无限魅力。',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Chinese%20manhua%20style%20illustration%20showcasing%20diverse%20characters%20from%20different%20Chinese%20comics%20gathered%20together%2C%20traditional%20Chinese%20elements%20blended%20with%20modern%20comic%20art%2C%20warm%20coral%20and%20gold%20tones%2C%20festive%20atmosphere&width=1200&height=600&seq=carousel-03&orientation=landscape',
    alt: '2024国漫年度盘点',
  },
  {
    id: 'focus-4',
    title: '「鬼灭之刃」全集重温指南',
    tag: '完结推荐',
    description: '吾峠呼世晴笔下的现象级作品，从炭治郎的成长到无惨的最终决战，每一场战斗都令人热血沸腾。飞飞漫画网提供鬼灭之刃漫画全集在线看与下载，一次性读完这部史诗。',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20manga%20style%20illustration%20of%20a%20young%20swordsman%20with%20his%20sister%20under%20a%20full%20moon%2C%20traditional%20Japanese%20aesthetic%2C%20water%20breathing%20visual%20effects%2C%20warm%20amber%20moonlight%2C%20emotional%20atmosphere%2C%20clean%20composition&width=1200&height=600&seq=carousel-04&orientation=landscape',
    alt: '鬼灭之刃全集重温',
  },
];

export const mediaData = [
  {
    id: 'media-1',
    title: '「咒术回战」动画第三季制作决定',
    tag: '动画资讯',
    description: 'MAPPA官方宣布咒术回战第三季"死灭回游篇"动画化启动，预计2026年播出。飞飞漫画网漫画全集已更新至最新话。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20manga%20style%20promotional%20illustration%20with%20characters%20in%20dynamic%20action%20poses%2C%20anime%20announcement%20style%20visual%2C%20warm%20coral%20and%20dark%20tones%2C%20dramatic%20lighting%2C%20cinematic%20composition&width=600&height=340&seq=media-01&orientation=landscape',
    alt: '咒术回战动画资讯',
  },
  {
    id: 'media-2',
    title: '「间谍过家家」剧场版票房破百亿',
    tag: '影视快报',
    description: '剧场版《间谍过家家 CODE: White》日本票房突破100亿日元，飞飞漫画网提供原作漫画全集免费阅读，感受原作的魅力。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20wholesome%20manga%20style%20illustration%20of%20a%20family%20of%20three%20with%20a%20dog%20in%20a%20warm%20living%20room%2C%20cozy%20atmosphere%2C%20soft%20warm%20lighting%2C%20Japanese%20comic%20art%20style%2C%20gentle%20amber%20and%20cream%20tones&width=600&height=340&seq=media-02&orientation=landscape',
    alt: '间谍过家家剧场版',
  },
  {
    id: 'media-3',
    title: '「电锯人」第二季动画PV公开',
    tag: '新番速递',
    description: '蕾塞篇动画PV正式公开，电锯人粉丝期待已久的名场面即将登场。漫画全集在线看飞飞漫画网已同步更新至最新话。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20gritty%20manga%20style%20illustration%20of%20a%20chainsaw%20wielding%20character%20in%20an%20urban%20night%20setting%2C%20neon%20accents%20with%20warm%20coral%20highlights%2C%20dark%20atmospheric%20background%2C%20cinematic%20composition&width=600&height=340&seq=media-03&orientation=landscape',
    alt: '电锯人第二季动画',
  },
  {
    id: 'media-4',
    title: '「排球少年」垃圾场决战篇热映',
    tag: '剧场追踪',
    description: '剧场版《垃圾场的决战》引发观影热潮，飞飞漫画网提供排球少年漫画全集下载，重温乌野与音驹的经典对决。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dynamic%20manga%20style%20illustration%20of%20volleyball%20players%20in%20an%20intense%20match%2C%20sports%20action%20scene%2C%20warm%20gymnasium%20lighting%2C%20Japanese%20comic%20art%20style%2C%20energetic%20composition%20with%20amber%20tones&width=600&height=340&seq=media-04&orientation=landscape',
    alt: '排球少年剧场版',
  },
];

export const updatesData = [
  { date: '07-28', tag: '更新', title: '「咒术回战」第271话已更新', desc: '最终决战进入白热化阶段' },
  { date: '07-28', tag: '新番', title: '「怪兽8号」正式入驻飞飞漫画网', desc: '全集同步上线，一口气看个够' },
  { date: '07-27', tag: '完结', title: '「黑子的篮球」漫画全集整理完毕', desc: '全275话高清版本已上线' },
  { date: '07-27', tag: '更新', title: '「海贼王」第1130话更新', desc: '艾尔巴夫篇剧情加速展开' },
  { date: '07-26', tag: '公告', title: '飞飞漫画网阅读器升级至3.0版本', desc: '新增夜间模式与智能分页功能' },
  { date: '07-26', tag: '更新', title: '「间谍过家家」第103话更新', desc: '福杰一家新任务启动' },
  { date: '07-25', tag: '推荐', title: '夏日纳凉特辑：10部必看悬疑漫画', desc: '精选悬疑推理漫画全集推荐' },
];

export const commentsData = [
  {
    id: 'comment-1',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20illustration%20of%20a%20cute%20anime%20style%20avatar%20with%20short%20black%20hair%2C%20friendly%20expression%2C%20simple%20warm%20background%2C%20minimal%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '漫画迷小王',
    time: '2小时前',
    content: '飞飞漫画网的漫画全集在线看体验真的太棒了！画质清晰，加载速度快，追更也特别及时。鬼灭之刃全集一口气看完了，太爽了！',
    likes: 256,
  },
  {
    id: 'comment-2',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20illustration%20of%20a%20cute%20anime%20style%20avatar%20with%20long%20brown%20hair%2C%20gentle%20smile%2C%20simple%20warm%20background%2C%20minimal%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '二次元小美',
    time: '5小时前',
    content: '用了很多漫画网站，还是飞飞漫画网最稳定。漫画全集下载功能简直是通勤救星，地铁上信号不好也能看，离线模式太实用了！',
    likes: 189,
  },
  {
    id: 'comment-3',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20illustration%20of%20a%20cute%20anime%20style%20avatar%20with%20spiky%20red%20hair%2C%20energetic%20expression%2C%20simple%20warm%20background%2C%20minimal%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '热血少年阿杰',
    time: '昨天',
    content: '咒术回战的更新速度太给力了，几乎是和日本同步！完结漫画的大全也很全，很多冷门老番都能找到，收藏夹已经爆满了哈哈。',
    likes: 312,
  },
  {
    id: 'comment-4',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20illustration%20of%20a%20cute%20anime%20style%20avatar%20with%20blue%20short%20hair%2C%20thoughtful%20expression%2C%20simple%20warm%20background%2C%20minimal%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '深夜追更人',
    time: '昨天',
    content: '飞飞漫画网的夜间模式必须好评！晚上躺床上看漫画眼睛不累，而且漫画全集都是高清的，放大看细节也很清楚。推荐给所有喜欢漫画的朋友！',
    likes: 145,
  },
];

export const faqData = [
  {
    q: '飞飞漫画网是免费的吗？',
    a: '飞飞漫画网所有漫画全集在线看均免费提供，无需付费订阅即可畅读全部内容。我们致力于为漫画爱好者打造最便捷的免费漫画全集阅读平台，完结漫画和连载漫画都可自由阅读。',
  },
  {
    q: '支持漫画全集下载吗？',
    a: '支持！飞飞漫画网提供漫画全集下载功能，你可以将喜欢的完结漫画或连载漫画下载到本地，在没有网络的环境下也能畅快阅读。下载格式为高清图片，兼容主流设备。',
  },
  {
    q: '漫画更新频率如何？',
    a: '飞飞漫画网与日本和国内漫画平台保持同步更新，热门连载漫画通常在日本发售后24小时内完成汉化和上架。完结漫画大全也在持续扩充中，每周都有新作品入库。',
  },
  {
    q: '如何找到想看的漫画？',
    a: '你可以通过飞飞漫画网顶部搜索栏按名称搜索，也可以通过分类标签按题材浏览，或者参考人气排行榜发现热门作品。此外，话题标签和主题索引也能帮你发现感兴趣的漫画全集。',
  },
];

export const topicsData = [
  { id: 'topic-1', name: '热血漫画', count: '1.2万部', icon: 'ri-fire-line', color: 'primary' },
  { id: 'topic-2', name: '恋爱漫画', count: '8,562部', icon: 'ri-heart-line', color: 'accent' },
  { id: 'topic-3', name: '悬疑推理', count: '3,421部', icon: 'ri-search-eye-line', color: 'primary' },
  { id: 'topic-4', name: '搞笑日常', count: '6,780部', icon: 'ri-emotion-laugh-line', color: 'accent' },
  { id: 'topic-5', name: '奇幻冒险', count: '9,234部', icon: 'ri-compass-3-line', color: 'primary' },
  { id: 'topic-6', name: '国漫精选', count: '5,120部', icon: 'ri-flag-2-line', color: 'accent' },
  { id: 'topic-7', name: '日漫经典', count: '1.8万部', icon: 'ri-sun-line', color: 'primary' },
  { id: 'topic-8', name: '运动竞技', count: '2,345部', icon: 'ri-basketball-line', color: 'accent' },
  { id: 'topic-9', name: '科幻未来', count: '4,210部', icon: 'ri-rocket-line', color: 'primary' },
  { id: 'topic-10', name: '恐怖惊悚', count: '1,890部', icon: 'ri-ghost-line', color: 'accent' },
];

export const featuresData = [
  {
    id: 'feature-1',
    icon: 'ri-smartphone-line',
    title: '全平台适配',
    description: '手机、平板、电脑无缝切换，漫画全集在线看随时随地。阅读进度云端同步，换设备也能接着看。',
  },
  {
    id: 'feature-2',
    icon: 'ri-bookmark-line',
    title: '海量漫画全集',
    description: '收录超过5万部漫画，涵盖完结漫画与连载作品，日漫国漫一应俱全。持续更新漫画大全，总有新发现。',
  },
  {
    id: 'feature-3',
    icon: 'ri-shield-check-line',
    title: '安全纯净阅读',
    description: '无弹窗广告干扰，纯净阅读环境。所有漫画全集经人工审核，确保内容合规，打造安心阅读空间。',
  },
];

export const indexData = [
  {
    id: 'index-1',
    title: '热血漫画全集',
    count: '1.2万部',
    description: '燃到爆的热血战斗漫画全集收录',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20manga%20style%20illustration%20of%20an%20intense%20battle%20scene%20with%20energy%20explosions%2C%20warm%20coral%20and%20amber%20toned%20comic%20art%2C%20dramatic%20composition%2C%20Japanese%20anime%20style&width=400&height=240&seq=index-01&orientation=landscape',
    alt: '热血漫画全集',
  },
  {
    id: 'index-2',
    title: '恋爱漫画大全',
    count: '8,562部',
    description: '甜蜜心动恋爱漫画合集',
    image: 'https://readdy.ai/api/search-image?query=A%20soft%20romantic%20manga%20style%20illustration%20of%20two%20characters%20under%20cherry%20blossoms%2C%20warm%20pink%20and%20amber%20tones%2C%20gentle%20spring%20atmosphere%2C%20Japanese%20shoujo%20manga%20style&width=400&height=240&seq=index-02&orientation=landscape',
    alt: '恋爱漫画大全',
  },
  {
    id: 'index-3',
    title: '完结漫画经典',
    count: '2,000+部',
    description: '已完结高分漫画一次性畅读',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20illustration%20of%20a%20collection%20of%20completed%20manga%20volumes%20stacked%20neatly%2C%20golden%20trophy%20symbolizing%20classics%2C%20soft%20amber%20lighting%2C%20library%20atmosphere&width=400&height=240&seq=index-03&orientation=landscape',
    alt: '完结漫画经典',
  },
  {
    id: 'index-4',
    title: '国漫崛起专区',
    count: '5,120部',
    description: '优秀国产漫画全集大赏',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Chinese%20manhua%20style%20illustration%20with%20traditional%20Chinese%20aesthetic%20elements%2C%20martial%20arts%20characters%2C%20warm%20coral%20and%20gold%20tones%2C%20dramatic%20composition&width=400&height=240&seq=index-04&orientation=landscape',
    alt: '国漫崛起专区',
  },
  {
    id: 'index-5',
    title: '悬疑推理馆',
    count: '3,421部',
    description: '烧脑悬疑漫画精选合集',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20manga%20style%20illustration%20with%20detective%20silhouette%20and%20clues%20scattered%2C%20warm%20amber%20light%20through%20window%20blinds%2C%20noir%20atmosphere%2C%20suspenseful%20composition&width=400&height=240&seq=index-05&orientation=landscape',
    alt: '悬疑推理馆',
  },
  {
    id: 'index-6',
    title: '搞笑漫画合集',
    count: '6,780部',
    description: '笑到停不下来的欢乐漫画',
    image: 'https://readdy.ai/api/search-image?query=A%20funny%20lighthearted%20manga%20style%20illustration%20with%20chibi%20characters%20in%20comedic%20poses%2C%20bright%20warm%20coral%20and%20yellow%20tones%2C%20playful%20composition%2C%20Japanese%20comedy%20manga%20style&width=400&height=240&seq=index-06&orientation=landscape',
    alt: '搞笑漫画合集',
  },
  {
    id: 'index-7',
    title: '奇幻冒险世界',
    count: '9,234部',
    description: '异世界与奇幻冒险漫画大全',
    image: 'https://readdy.ai/api/search-image?query=A%20fantastical%20manga%20style%20illustration%20of%20a%20magical%20world%20with%20floating%20islands%20and%20adventurers%2C%20warm%20golden%20sunlight%2C%20epic%20fantasy%20atmosphere%2C%20Japanese%20isekai%20style&width=400&height=240&seq=index-07&orientation=landscape',
    alt: '奇幻冒险世界',
  },
  {
    id: 'index-8',
    title: '运动漫画特辑',
    count: '2,345部',
    description: '热血运动竞技漫画全收录',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20sports%20manga%20style%20illustration%20with%20various%20sports%20characters%20in%20action%2C%20warm%20stadium%20lighting%2C%20energetic%20composition%2C%20Japanese%20sports%20manga%20style&width=400&height=240&seq=index-08&orientation=landscape',
    alt: '运动漫画特辑',
  },
];

export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '精选漫画', href: '#cards' },
  { label: '人气排行', href: '#ranking' },
  { label: '热门话题', href: '#topics' },
  { label: '读者点评', href: '#comments' },
  { label: '最新动态', href: '#updates' },
];